<template>
  <div>
    <Login v-show="currentBox === 'login'"></Login>
  </div>
</template>

<script>
import Login from './Login'

export default {
  name: 'AccountContentZH',
  props: ['isShow'],
  components: { Login },
  data () {
    return {
      currentBox: 'login'
    }
  },
  watch: {
    isShow (newVal, oldVal) {
      if (!newVal) {
        this.currentBox = 'login'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/zh-CN/Content.vue